import React from 'react';
import { Patient } from '~/components/Patient';
import { ClientContext, PatientProvider } from '~/services';

export function PatientView() {
    const clientContext = React.useContext(ClientContext);
    return (
        <PatientProvider>
            <div className="container">
                <Patient reportYear={clientContext.reportYear} />
            </div>
        </PatientProvider>
    );
}
